import { Icon } from '@/src/components/ui';
import moment from 'moment';

type Props = {
  likes: number;
  comments: number;
  createdAt: string;
  className?: string;
  isPrivateBit?: boolean;
};

export const Stats = ({
  likes,
  comments,
  createdAt,
  className,
  isPrivateBit,
}: Props) => {
  return (
    <div
      className={`h-4 text-xs flex items-center justify-between mt-4 px-2 ${className}`}
    >
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1">
          <Icon name="like" className={` size-3 ${className}`} /> {likes}
        </span>
        <span className="flex items-center gap-1">
          <Icon name="comment" className={` size-3 ${className}`} /> {comments}
        </span>
        {isPrivateBit && (
          <span className="flex items-center gap-1">
            <img
              src="/icons/unlock.png"
              className={` size-3 text-black ${className}`}
            />
          </span>
        )}
      </div>
      <p className={className}>{moment(createdAt).fromNow()}</p>
    </div>
  );
};
